import { Loans } from '@src/containers/Blotters/OTC/Loans/Loans';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { LoansBlotterPanelConfig } from '../../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function LoansPanel({ params, api }: LayoutPanelProps<LoansBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.LoansBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="loans-panel"
      >
        <Loans />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
